/**
 * Opens an in-app path in its own browser tab.
 *
 * `noopener,noreferrer` — the new tab gets no handle on this one, so a
 * document view can never reach back into the operating surface that spawned it.
 */
export function openInNewTab(path: string): void {
  window.open(path, '_blank', 'noopener,noreferrer');
}
